import styled from 'styled-components';
import { MenuItem } from '@mui/material';

const StyledMenuItem = styled(MenuItem)({
  fontSize: '14px',
  height: '20px'
});

export default StyledMenuItem;
